import { FormEvent, useState } from "react";

import { updateArticleWithUrl } from "@/api/article";

import ConfirmModal from "@/components/common/modals/confirm-modal";

import { Button } from "@/components/ui/button/index.tsx";
import { Input } from "@/components/ui/input";

const ArticleUrlPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const url = formData.get("url") as string;

    try {
      await updateArticleWithUrl(url);
      setIsModalOpen(true);
    } catch {
      // Don't show modal on error
    }
  };
  return (
    <>
      <ConfirmModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onConfirm={async () => {
          setIsModalOpen(false);
        }}
        onCancel={async () => {}}
        title="مقالات شما با موفقیت در صف بررسی قرار گرفت  "
        content="مقالات پس از بررسی در لیست در انتظار تایید مالکیت ذخیره خواهند شد لطفا آنها را بررسی کنید و تایید مالکیت نمایید."
        confirmText="تایید"
      />
      <form onSubmit={handleSubmit} className="p-10">
        <div className="mb-10 flex max-w-[50%] items-center gap-x-2">
          <p className="text-nowrap">URL:</p>
          <Input type="text" name="url" placeholder="article" dir="ltr" />
        </div>
        <div>
          <Button type="submit" className="w-full max-w-[200px]">
            جست و جو
          </Button>
        </div>
      </form>
    </>
  );
};

export default ArticleUrlPage;
